import { __require as q } from "./conversions.js";
var l, f;
function b() {
  if (f) return l;
  f = 1;
  var i = q();
  function p() {
    var e = {},
      n = Object.keys(i);
    for (var r = n.length, t = 0; t < r; t++) e[n[t]] = {
      distance: -1,
      parent: null
    };
    return e;
  }
  function d(e) {
    var n = p(),
      r = [e];
    for (n[e].distance = 0; r.length;) {
      var t = r.pop(),
        o = Object.keys(i[t]);
      for (var s = o.length, c = 0; c < s; c++) {
        var u = o[c],
          a = n[u];
        a.distance === -1 && (a.distance = n[t].distance + 1, a.parent = t, r.unshift(u));
      }
    }
    return n;
  }
  function h(e, n) {
    return function (r) {
      return n(e(r));
    };
  }
  function v(e, n) {
    var r = [n[e].parent, e];
    var t = i[n[e].parent][e],
      o = n[e].parent;
    for (; n[o].parent;) r.unshift(n[o].parent), t = h(i[n[o].parent][o], t), o = n[o].parent;
    return t.conversion = r, t;
  }
  return l = function l(e) {
    var n = d(e),
      r = {},
      t = Object.keys(n);
    for (var o = t.length, s = 0; s < o; s++) {
      var c = t[s];
      n[c].parent !== null && (r[c] = v(c, n));
    }
    return r;
  }, l;
}
export { b as __require };